import { push } from "connected-react-router";
import React from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { Button } from "../../components/RegularComponents";

export const RegProgramCompletedQuestionView = (props) => {
    const dispatch = useDispatch();
    
    const handleNext = completedRegInfoProgram => () => {
        //dispatch(setCompletedRegInfoProgram(completedRegInfoProgram))

        const nextPath = completedRegInfoProgram ? ROUTE_PATH.MRA_PRINCIPAL_BROKER : ROUTE_PATH.MRA_COMPLETED_REG_PROGRAM_QUESTION_NO
        dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`))
    }
    return (
        <div className="container" >
            <div className="row bottomMarginNormal" >
                <div className="col-xs-12 col-lg-8">
                    <h1>Have you completed the regulatory information program?</h1>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-2">
                    <Button
                        id="completed-rg-program-yes-button"
                        className={"ns-btn-yes-no btn-default"}
                        buttonType="regular_primary"
                        onClick={handleNext(true)}
                        text={"Yes"}
                    />
                </div>

                <div className="col-lg-2">
                    <Button
                        id="completed-reg-program-no-button"
                        className={"ns-btn-yes-no btn-default"}
                        buttonType="regular_primary"
                        onClick={handleNext(false)}
                        text={"No"}
                    />
                </div>
            </div>
        </div>
    )
}